//upsell cart
//   - button.add-to-cart (trigger button)

theme.upsellCart = function() {

  var templateData = null;

  var slideShowObj = null;

  var productId = null;

  var productContainer = document.querySelectorAll('.product-section');
  if (productContainer.length > 0) {
    productId = productContainer[0].getAttribute('data-product-id');
  }
  
  
  var url = 'https://new-app.savedbythedress.net/api/product/upsell/get-active?pid=' + productId;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((response) => {

      if (response.errors || !response.data) {
  return;
    }
      templateData = response.data.productData; 
      loadData(templateData);
        
    });


  document.addEventListener('drawerOpen.CartDrawer', (data) => {

    if (slideShowObj) {
      return;
    }
    var defaults = {
      adaptiveHeight: false,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
      contain: true,
      groupCells: true
    };

    
    slideShowObj = holderDiv.querySelector('#Upsell-Slideshow');


    setTimeout(() => {
      var flickity = new theme.Slideshow(slideShowObj, defaults);        
    }, 50);
  });
  
  var holderId = 'UpsellCart';
  
  var holderDiv = document.getElementById(holderId);
  

  function loadData(data) {
    var slideshowContainer = holderDiv.querySelector('.slideshow-wrapper');

    slideshowContainer.innerHTML = '';
    slideshowContainer.innerHTML = getTemplate();
    
  }

  function getTemplate() {
    
    let out = `<div class="upsell-title">MAYBE YOU'LL ALSO LIKE</div>
    <div class="upsell-slider" id="Upsell-Slideshow">`;
    for( var v in templateData) {
      out += getTemplateItem(templateData[v]);
    }

    out += `</div>`;

    return out;
  }

  function getTemplateItem(oneItem) {
    return `<div class="upsell-item-cart">
                      <div class="upsell-image-cart">
                        <div class="text-spacing-upsell-cart">
                          <img class="lazyloaded" src="${oneItem.image}" alt="Select additional product">
                        </div>
                      </div>

                      <div class="grid-product__meta">
                        <div class="upsell-cart-product-title">${oneItem.title}</div>
                        <div class="upsell-cart-product-price">$ ${oneItem.price}</div>
                      </div>

                      <div class="upsell-buttons">
                      <div class="btn add-to-cart btn--secondary" style="margin: auto;" onclick="openUpsellItem('${oneItem.url}')">View</div>
                      </div>
                </div>`;
  }


};

function openUpsellItem(url) {
  document.location.href= url;
}
